import { fromJS, Map, List } from 'immutable';
import { checkSameReservation, roomAsServiceBreakDown } from './reservationUtils';

import api from '@synergycms_core/utils/api';
import actions from '../../actions';
import storage from '@synergycms_core/utils/storage';

import { pluck, is, concat, values, keys, pipe, reduce, __, map, when, equals, reject, has } from 'ramda';

import { set, get } from '@synergycms_core/utils';
import loggerGetter from '@synergycms_core/utils/logger';
import Cookies from '@synergycms_core/utils/cookies';

const reservationError = (error, dispatch) => {
  if (error.name === 409) {
    dispatch(actions.notifications.send('error', error.message));
  } else if (error.message !== 'Promotion code not applicable') {
    dispatch(actions.notifications.send('error', '_%error al procesar su reserva, por favor, vuelva a intentarlo%_'));
  }

  return Promise.reject(error);
};

export default {
  SET: reservation => {
    return (dispatch, getState) => {
      if (reservation.get('tracking_id', false)) {
        storage.set('reservation-' + reservation.get('tracking_id'), reservation.toJS());
      }
      return reservation;
    };
  },
  GET_ASYNC: (trackingId, pinCode) => {
    return (dispatch, getState) => {
      const store = getState(),
        hotelId = store.getIn(['customer', 'current_hotel']);
      const extraHeaders = [{ Authorization: 'Basic ' + btoa(trackingId + ':' + pinCode) }];

      return api
        .get('cms/reservations/' + trackingId, {}, hotelId, extraHeaders)
        .then(response => {
          return !(response.success === false) ? fromJS(response) : Map({ success: false });
        })
        .catch(err => {
          reservationError(err, dispatch);
          return Map({ success: false });
        });
    };
  },
  GET_TMS_ASYNC: (trackingId, pinCode) => {
    return (dispatch, getState) => {
      const store = getState(),
        hotelId = store.getIn(['customer', 'current_hotel']);
      const extraHeaders = [{ Authorization: 'Basic ' + btoa(trackingId + ':' + pinCode) }];

      return api
        .get('cms/reservations_tms/' + trackingId, {}, hotelId, extraHeaders)
        .then(response => {
          return !(response.success === false) ? fromJS(response) : Map({ success: false });
        })
        .catch(err => {
          reservationError(err, dispatch);
          return Map({ success: false });
        });
    };
  },
  POST_ASYNC: (newParamsReservation, cleanReservation = true) => {
    return (dispatch, getState) => {
      const store = getState();
      const hotelId = store.getIn(['customer', 'current_hotel']);
      const serviceQueryParams = store.getIn(['hotels', hotelId, 'params', 'string_service_query_params']);
      const hotelServicesAvail = store.getIn(
        ['availServices', hotelId, serviceQueryParams, 'response', 'services'],
        List()
      );

      let reservationRequest = store.getIn(['customer', 'reservation_request']);

      // Cerquem habitacions + paquet
      reservationRequest = roomAsServiceBreakDown(reservationRequest, hotelServicesAvail);

      if (newParamsReservation) {
        reservationRequest = reservationRequest.merge(newParamsReservation);
      }

      const previousReservation = store.getIn(['customer', 'reservation'], false);

      if (!newParamsReservation && checkSameReservation(reservationRequest, previousReservation)) {
        return Promise.resolve(previousReservation);
      } else {
        if (cleanReservation && previousReservation && previousReservation.size > 0) {
          dispatch(actions.customer.reservation.set(Map()));
        }
        reservationRequest = reservationRequest.setIn(
          ['customer', 'web_type'],
          store.getIn(['customer', 'web_type'], null)
        );

        if(store.getIn(['customer','reservation','pin_code'],false)) {
          reservationRequest = reservationRequest.setIn(
            ['pin_code'],
            store.getIn(['customer','reservation','pin_code'], false)
          );
        }

        const loyaltyUser = store.getIn(['customer', 'loyalty', 'user'], null);
        if (loyaltyUser) {
          reservationRequest = reservationRequest
            .setIn(['customer', 'name'], loyaltyUser.get("name"))
            .setIn(['customer', 'email'], loyaltyUser.get("email"));
        }

        return api
          .post('cms/post_reservation', reservationRequest.toJS(), hotelId)
          .then(response => {
            if (response.success !== false && typeof response.tracking_id !== 'undefined') {
              let reservationRequest = storage.get('last_reservation_request');
              reservationRequest.booking_date = response.booking_date;

              storage.set('reservation-' + response.tracking_id, response);
              storage.set('last_reservation_request', reservationRequest);
              return fromJS(response);
            } else if (response.error && response.error === 'Promotion code not applicable') {
              // Ho comento pq ja surt l'error al propi input, poder no cal 2 vegades no?
              // dispatch(actions.notifications.send('error', '_%código promocional no aplicable%_'));
              return Promise.reject(Error(response.error));
            } else {
              dispatch(actions.customer.step.prev());
              return reservationError(Error('reservation error'), dispatch);
            }
          })
          .then(reservation => {
            if (reservation) {
              dispatch(
                actions.customer.corporate.setPayformsAsync(reservation.get('tracking_id'), reservation.get('pin_code'))
              );
            }
            return reservation;
          })
          .catch(error => {
            return reservationError(error, dispatch);
          });
      }
    };
  },
  PATCH_ASYNC: (
    model,
    inputList,
    {
      extraFields = false,
      blockIdx = 0,
      cancelReservation = false,
      paymentToken = false,
      merchantTransactionId = false,
      amazonOrderRefId = false,
      PayPalOrderId = false,
      payed = false,
      tpvId = false,
      tpvCode = false,
      TPVnRetry = false,
      fromSuccessCof = false,
      requiredFields=[],
      forcePayformOP = false
    } = {}
  ) => {
    return (dispatch, getState) => {
      const store = getState();
      /**
       * pendents:
       *
       * travel_reason?
       */
      let reservation = store.getIn(['customer', 'reservation']);
      const trackingId = reservation.get('tracking_id');
      const hotelId = store.getIn(['customer', 'current_hotel']);
      const showTaxes = store.getIn(['hotels', hotelId, 'show_taxes']);


      let modelList;
      if (is(Array, model)) {
        modelList = model;
      } else if (model) {
        modelList = [model];
      } else {
        modelList = pluck('model')(values(inputList));
      }

      if (extraFields) {
        modelList = concat(modelList, ['source_url', 'lang', 'currency_code']);
      }

      const mapList = {
        /**
         * CUSTOMER FORM
         */
        name: {
          path: ['customer', 'name']
        },
        surname: {
          path: ['customer', 'surname']
        },
        email: {
          path: ['customer', 'email']
        },
        phone: {
          path: ['customer', 'phone']
        },
        travel_reason: {
          path: ['customer', 'travel_reason']
        },
        country: {
          path: ['customer', 'country'],
          callback: (inputList, key) => inputList[key]?.value.get('alpha2')
        },
        state: {
          path: ['customer', 'state'],
          callback: (inputList, key) => typeof inputList[key] !== 'undefined' && inputList[key].value.get('code')
        },
        nationality: {
          path: ['customer', 'nationality'],
          callback: (inputList, key) => inputList[key]?.value.get('alpha2')
        },
        document_type: {
          path: ['customer', 'document_type'],
          callback: (inputList, key) => inputList[key]?.value.value || null,

        },
        hours_arrival: {
          path: ['customer', 'hours_arrival'],
          callback: (inputList, key) => {
            return inputList[key]?.value.value
          }
        },
        tax_number: {
          path: ['customer', 'tax_number'],
          defaultValue : null
        },
        notes: {
          path: ['customer', 'notes']
        },
        card_holder: {
          path: ['customer', 'card_holder']
        },
        GDPR_accepted: {
          path: ['customer', 'GDPR_accepted']
        },
        GDPR_loyalty: {
          path: ['customer', 'GDPR_loyalty'],
          callback: (inputList, key) => {
            if(inputList[key]) {
              return inputList[key]?.value
            } else {
              return false;
            }
          },
        },
        check_loyalty: {
          path: ['customer', 'check_loyalty']
        },
        required_policies: {
          path: ['customer', 'required_policies']
        },
        country_iso_code: {
          path: ['customer', 'country_iso_code']
        },
        travelclub_card: {
          path: ['travelclub', 'travelclub_card']
        },
        currency_code: {
          path: ['customer', 'currency_code'],
          defaultValue: store.getIn(['customer', 'current_currency'])
        },
        source_url: {
          path: ['customer', 'source_url'],
          defaultValue: window.location.href
        },
        lang: {
          path: ['customer', 'lang'],
          defaultValue: store.getIn(['customer', 'lang_info', 'code']).toLowerCase()
        },
        /**
         * ROOM PREFERENCES
         */
        preferences: {
          path: ['preferences'],
          callback: inputList => {
            const preferencesKeys = keys(inputList);
            return preferencesKeys.reduce((blockPreferences, preferenceKey) => {
              const preferencesIds = preferenceKey.split('room_preference_')[1];
              const preferenceId = +preferencesIds.split('-')[0];
              const optionId = +inputList[preferenceKey].value.get('id');
              blockPreferences.push({
                preference_id: String(preferenceId),
                option_id: String(optionId)
              });
              return blockPreferences;
            }, []);
          }
        },
        /**
         * CONFIRMATION
         */
        status: {
          defaultValue: cancelReservation ? 'cancelled' : 'confirmed'
        },
        payment: {
          path: ['payment'],
          callback: inputList => {
            let fullFreeReservation = store.getIn(['customer', 'reservation', 'penalties', 0], false);
            fullFreeReservation = (fullFreeReservation.get('release', null) === 23976 && fullFreeReservation.get('type', null) === 'percentage'
              && fullFreeReservation.get('value', null) === 0 && fullFreeReservation.get('show_as', null) === 'days');
            let payFormCode = (fullFreeReservation && 'htl') || inputList['payForm'].value.get('code');
            if(forcePayformOP) {
              payFormCode = 'op'
            }
            let paymentBody = {
              payform_code: payFormCode,
              amount_pending: payed ? 0 : reservation.get(showTaxes ? 'total_price_tax' : 'total_price'),
              state: payed ? 'payed' : 'pending',
              token: paymentToken
            };

            if (reservation.getIn(['payment', 'amount_promo_paid'])) {
              paymentBody = Object.assign(paymentBody, {
                amount_promo_paid: reservation.getIn(['payment', 'amount_promo_paid'])
              });
            }
            if (reservation.getIn(['payment', 'loyalty_points'])) {
              paymentBody = Object.assign(paymentBody, {
                loyalty_points: reservation.getIn(['payment', 'loyalty_points'])
              });
            }
            if (reservation.get('status') !== 'confirmed' && !payed) {
              // evitem que per un error es setegi una reserva pagada a zero
              paymentBody = Object.assign(paymentBody, {
                amount_paid: payed ? reservation.get(showTaxes ? 'price_tax' : 'price') : 0
              });
            }
            if (!payed && fromSuccessCof) {
              delete paymentBody.state;
              delete paymentBody.amount_pending;
              delete paymentBody.amount_paid;
            } else if(payed && fromSuccessCof) {
              paymentBody = Object.assign(paymentBody, {
                amount_paid: reservation.get(showTaxes ? 'total_price_tax' : 'total_price')
              });
            }

            if (tpvId) {
              paymentBody = Object.assign(paymentBody, { tpv_id: tpvId });
            }
            if (tpvCode) {
              paymentBody = Object.assign(paymentBody, { tpv_code: tpvCode });
            }
            if (TPVnRetry) {
              paymentBody = Object.assign(paymentBody, { n_retry: TPVnRetry });
            }
            if (merchantTransactionId) {
              paymentBody = Object.assign(paymentBody, { merchant_transaction_id: merchantTransactionId });
            }
            if (amazonOrderRefId) {
              paymentBody = Object.assign(paymentBody, { amazon_order_reference_id: amazonOrderRefId });
            }
            if (PayPalOrderId) {
              paymentBody = Object.assign(paymentBody, { paypal_order_id: PayPalOrderId });
            }

            if (payFormCode === 'bizum') {
              paymentBody = Object.assign(paymentBody,
                {
                  bizum_charge: true,
                  payform_code: 'op'
                });
            } else {
              paymentBody = Object.assign(paymentBody,
                {
                  bizum_charge: false
                });
            }
            return paymentBody;
          }
        },
        /**
         * ATTRIBUTION MODEL
         */
        td: {
          path: ['customer', 'td'],
          callback: () => storage.get('td')
        },
        tds: {
          path: ['customer', 'tds'],
          callback: () => Cookies.getObjKeysByPattern('tds_')
        },
        tdd: {
          path: ['customer', 'tdd'],
          callback: () => Cookies.getObjKeysByPattern('tdd_')
        },
        tdf: {
          path: ['customer', 'tdf'],
          callback: () => Cookies.getObjKeysByPattern('tdf_')
        },
        td_history: {
          path: ['customer', 'td_history'],
          callback: () => {
            const tdHistoryData = Cookies.getObjKeysByPattern('td_history');
            return tdHistoryData['td_history'];
          }
        },
        POS: {
          path: ['customer', 'POS'],
          callback: () => storage.getLocal('POS')
        },
        chosen_currency: {
          path: ['customer', 'chosen_currency'],
          callback: () => store.getIn(['customer', 'current_currency'])
        },
        trv_reference: {
          path: ['customer', 'trv_reference'],
          defaultValue: store.getIn(['customer', 'params', 'params', 'trv_reference'], false)
        },
        allow_loyalty_point_redemption: {
          path: ['customer', 'allow_loyalty_point_redemption']
        },
        addressLine1: {
          path: ['customer', 'addressLine1']
        },
        customerCountry: {
          path: ['customer', 'customerCountry'],
          callback: (inputList, key) => inputList[key]?.value.get('alpha2')
        },
        customerCity: {
          path: ['customer', 'customerCity']
        },
        postCode: {
          path: ['customer', 'postCode']
        },
        booker_name: {
          path: ['customer', 'guest_booker', 'booker_name']
        },
        booker_surname: {
          path: ['customer', 'guest_booker', 'booker_surname']
        },
        booker_email: {
          path: ['customer', 'guest_booker', 'booker_email']
        },
      };

      /**
       *
       "payform_code" : "htl",
       "amount_paid" : 0,
       "amount_pending" : 2074.05,
       "state" : "pending",
       */
       const hasDefaultValue = has('defaultValue');

      let reservationObj = modelList.reduce((reservations, model) => {
        const key = is(Object, model) ? keys(model)[0] : model;
        const mapObj = mapList[key];
        const path = (mapObj && mapObj.path) || key;

        let value;
        if (is(Object, model) && model[key]) {
          value = model[key];
        } else if (hasDefaultValue(mapObj) && mapObj?.callback) {
          value =  mapObj.callback(inputList, key) || mapObj.defaultValue;
        } else if (mapObj?.callback) {
          value = mapObj.callback(inputList, key);
        } else if (inputList && inputList[key]) {
          value = get('value', inputList[key]);
        } else if (hasDefaultValue(mapObj)) {
          value =  mapObj.defaultValue;
        }

        return set(path, value, reservations);
      }, {});

      const clean = (o)=>pipe(reject(equals(undefined)),map(when(is(Object), clean)))(o);

      reservationObj = clean(reservationObj);
      // Symantec - BlueCoat
      // Posem el pin code al body per evitar firewalls que rebenten el header Authorization
      reservationObj.pin_code = reservation.get('pin_code');

      // newCOF variation
      if (
        typeof reservationObj.customer !== 'undefined' &&
        typeof reservationObj.customer.email === 'undefined' &&
        !!reservation.getIn(['customer', 'email'], false)
      ) {
        let country = reservationObj.customer.country || false;
        let state = reservationObj.customer.state || false;
        reservationObj.customer = reservation.get('customer').toJS();
        if(country) {
          reservationObj.customer.country = country;
        }
        if(state) {
          reservationObj.customer.state = state;
        }
      } /*else if (loyaltyUser && !reservationObj.customer) {
          const {email, name} = loyaltyUser.toJS();
          Object.assign(reservationObj, { customer: {
              email: email,
              name: name,
              source_url: mapList.source_url.defaultValue,
              lang: mapList.lang.defaultValue
          }});
      }*/

      const extraHeaders = [{ Authorization: 'Basic ' + btoa(trackingId + ':' + reservation.get('pin_code')) }];
      const logger = loggerGetter();
      if (reservationObj.status === 'confirmed') {
        logger.addLine('prepatch confirm booking', reservationObj);
      }
     //const validationFields = ['email', 'repeatEmail'];

      let request = Promise.resolve(reservation.toJS());
      //if (blockIdx || validationFields.every(field => inputList[field] && inputList[field].validation.valid)) {
      if (!requiredFields.length || (requiredFields.length && requiredFields.every(field => inputList[field] && inputList[field].validation && inputList[field].validation.valid))) {
        request = api.patch(
          `cms/reservations/${trackingId}${blockIdx ? '/blocks/' + blockIdx + '/preferences' : ''}`,
          reservationObj,
          hotelId,
          extraHeaders
        );
      }
      var response = request.then(res => {
        reservation = getState().getIn(['customer', 'reservation']);
        console.warn("PATCH RESERVATION",res);
        if (res.success !== false) {
          storage.set('reservation-' + res.tracking_id, res);
          if (reservationObj.status === 'confirmed') {
            logger.addLine('patch resolved', '');
          }
          if (blockIdx) {
            blockIdx = +blockIdx;
            const affectedBlock = res.blocks.find(b => b.idx === blockIdx);
            dispatch(actions.customer.reservationRequest.addRoomPreferences(blockIdx, affectedBlock.preferences));
            return reservation
              .setIn(['blocks', blockIdx - 1, 'preferences'], fromJS(affectedBlock.preferences))
              .set('preferences', fromJS(res.preferences));
          }

          return pipe(
            reduce((newReservation, key) => newReservation.set(key, fromJS(reservationObj[key])), __, keys(reservationObj)),
            reduce((newReservation, key) => newReservation.set(key, fromJS(res[key])), __, ['update_time', 'travelclub', "loyalty"])
          )(reservation);
        } else {
          logger.addLine('patch reservation succcess : false', res);
          if (typeof reservationObj.status !== 'undefined') {
            return reservationError(Error('reservation error'), dispatch);
          }
        }
      }).catch(err => {
        logger.addLine('patch error', err);
        if (typeof reservationObj.status !== 'undefined') {
          dispatch(
            actions.notifications.send(
              'error',
              '_%ha ocurrido un error con el proceso de reserva, por favor, vuelva a intentarlo%_'
            )
          );
        }
        return reservationError(err, dispatch);
      });


      return response;
    };
  },
  PATCH_TMS_ASYNC: (
    model,
    inputList
  ) => {
    return (dispatch, getState) => {
      const store = getState();
      const hotelId = store.getIn(['customer', 'current_hotel']);
      let reservation = store.getIn(['customer', 'reservation']);
      const trackingId = reservation.get('tracking_id');

      let modelList;
      if (is(Array, model)) {
        modelList = model;
      } else if (model) {
        modelList = [model];
      } else {
        modelList = pluck('model')(values(inputList));
      }

      const mapList = {
        country: {
          path: ['country'],
          callback: (InputList, key) => InputList[key].value.get('alpha2')
        },
        state: {
          path: ['state'],
          callback: (InputList, key) => InputList[key].value.get('code')
        }
      };

      let reservationObj = modelList.reduce((reservations, model) => {
        const key = is(Object, model) ? keys(model)[0] : model;
        const mapObj = mapList[key];
        const path = (mapObj && mapObj.path) || key;
        let value;
        if (is(Object, model) && model[key]) {
          value = model[key];
        } else if (mapObj && (mapObj.defaultValue || mapObj.callback)) {
          value = mapObj.defaultValue || mapObj.callback(inputList, key);
        } else if (inputList && inputList[key]) {
          value = get('value', inputList[key]);
        }
        return set(path, value, reservations);
      }, {});

      // Symantec - BlueCoat
      // Posem el pin code al body per evitar firewalls que rebenten el header Authorization
      reservationObj.pin_code = reservation.get('pin_code');
      const extraHeaders = [{ Authorization: 'Basic ' + btoa(trackingId + ':' + reservation.get('pin_code')) }];
      return api
        .patch(
          `cms/reservations_tms/${trackingId}`,
          reservationObj,
          hotelId,
          extraHeaders
        )
        .then(res => {
          if (res.success !== false && typeof res.tracking_id !== 'undefined') {
            return pipe(
              reduce((newReservation, key) => newReservation.set(key, fromJS(res[key])), __, ['update_time']),
              reduce((newReservation, key) => newReservation.set(key, fromJS(reservationObj[key])), __, keys(reservationObj))
            )(reservation);
          } else {
            if (typeof reservationObj.status !== 'undefined') {
              return reservationError(Error('reservation error'), dispatch);
            }
          }
        })
        .catch(err => {
          if (typeof reservationObj.status !== 'undefined') {
            dispatch(
              actions.notifications.send(
                'error',
                '_%ha ocurrido un error con el proceso de reserva, por favor, vuelva a intentarlo%_'
              )
            );
          }
          return reservationError(err, dispatch);
        });
    };
  }
};
